import React, { useEffect, useState } from "react";
import styles from "./index.module.css";
import Modal from "../../Components/Modal";
import { rejectTrip } from "../Home/homeActions";
import { useDispatch, useSelector } from "react-redux";
import { useTranslation } from "react-i18next";
import { EQUIPMENT_MAP } from "../../helpers/constants";
import headerImage from "../../assets/patient_transport.png";
import { updateClubbedTripStatus } from "../Transports/action";
import RejectionReason from "./RejectionReason";
import SwipeButton from "../../Components/SwipeButton";
import SwipeButtonRTL from "../../Components/SwipeButtonRTL";
import { shifterTripSeenUpdate } from "../../services/api/shifterSeenUpdate";

const PatientTrip = ({ tripDetails }) => {
  const {
    rejection_reasons_patient: rejectionReason = [],
    allow_trip_rejection: rejectionEnabled = true,
  } = useSelector((state) => state.login.user);

  const dispatch = useDispatch();
  const { t } = useTranslation();
  const [isReject, toggleReject] = useState(false);
  const [isAccept, toggleAccept] = useState(false);
  const [isReason, toggleReason] = useState(false);

  const {
    booking_request: { equipment, oxygen_required: oxygenRequired } = {},

    shifter_type: shifterType,

    trip_number: tripNumber,
    trip_seen: tripSeen,
  } = tripDetails;

  useEffect(() => {
    if (!tripSeen) {
      dispatch(shifterTripSeenUpdate("seen"));
    }
  }, []);

  const handleReject = () => {
    if (rejectionReason?.length > 0) {
      toggleReason(true);
      toggleReject(true);
    } else {
      toggleReject(true);
      dispatch(rejectTrip(tripDetails?.id, "", () => toggleReject(false)));
    }
  };

  return (
    <div className={styles.trip_assigned}>
      <Modal fullModal>
        <div className={styles["clubbed-trip"]}>
          <img
            src={headerImage}
            alt="Patient Transport"
            className={styles["clubbed-trip__image"]}
          />
          <div className={styles["clubbed-trip__data"]}>
            <label>{`${t("Trip ID")} : ${tripNumber}`}</label>
            <label>{`${t("Mode")} : ${
              shifterType === "primary" ? t("Main") : t("Support")
            }`}</label>
            {equipment && (
              <label className={styles["clubbed-trip__equipment"]}>
                {`${t("Equipment")} :`}
                {EQUIPMENT_MAP?.[equipment]}
              </label>
            )}
            {oxygenRequired && (
              <label className={styles["clubbed-trip__oxygen"]}>
                {t("Oxygen Required")}
              </label>
            )}
          </div>
          <SwipeButton
            onComplete={() => {
              toggleAccept(true);
              dispatch(
                updateClubbedTripStatus(
                  tripDetails?.id,
                  "shifter_accepted",
                  {},
                  () => toggleAccept(false)
                )
              );
            }}
            loader={isAccept}
            label={t("Accept")}
          />
          {rejectionEnabled && (
            <SwipeButtonRTL
              onComplete={handleReject}
              loader={isReject}
              label={t("Reject")}
            />
          )}
        </div>
      </Modal>
      {isReason && (
        <Modal
          bottomModal
          onCancel={() => {
            toggleReason(false);
            toggleReject(false);
          }}
        >
          <RejectionReason
            reasons={rejectionReason}
            tripId={tripDetails?.id}
            onClose={() => {
              toggleReason(false);
              toggleReject(false);
            }}
          />
        </Modal>
      )}
    </div>
  );
};

export default PatientTrip;
